<div class="dropdown-container" [style.width]="width">
  <span class="input-title">
    {{ label }}<span *ngIf="required" class="asterisk">*</span>
  </span>
  <mat-form-field [appearance]="appearance" class="dropdown-field" [class.has-error]="hasError()" [class.mat-invalid]="hasError()">

    @if (prefix) {
      <div class="prefix-container"
           [class.prefix-start]="prefixAlign === 'start'"
           [class.prefix-center]="prefixAlign === 'center'"
           [class.prefix-end]="prefixAlign === 'end'"
           [class]="prefixContainerClass"
           [style]="prefixContainerStyles">
        @if (prefix.type === 'icon') {
          <mat-icon [class]="prefixClass"
                    [style]="prefixStyles"
                    [style.width]="prefixSize"
                    [style.height]="prefixSize">
            {{ prefix.value }}
          </mat-icon>
        }
        @if (prefix.type === 'image') {
          <img [src]="prefix.value"
               [alt]="prefix.alt || ''"
               [class]="prefixClass"
               [style]="prefixStyles"
               [style.width]="prefixSize || '22'"
               [style.height]="prefixSize || '22'">
        }
      </div>
    }

    <mat-select
    [value]="value"
    [placeholder]="placeholder"
    [required]="required"
    [multiple]="multiple"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="onDropdownOpened($event)"
    (closed)="onSelectClosed()"
      #select>

      @if (showClearButton && value && !disabled) {
        <div class="select-header">
          <button mat-button color="warn" (click)="clearSelection(); $event.stopPropagation()">
            <mat-icon>clear</mat-icon>
            Clear
          </button>
        </div>
      }

      @if (searchable) {
        <div class="search-container">
          <mat-form-field class="search-field">
            <input matInput
                  [placeholder]="searchPlaceholder"
                  (keyup)="onSearchChange($event)"
                  [value]="searchText"
                  (click)="$event.stopPropagation()">
            @if (loading) {
              <mat-icon matSuffix>hourglass_empty</mat-icon>
            }
          </mat-form-field>
        </div>
      }

      @if (loading) {
        <div class="loading-container">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      }

      @for (option of filteredOptions; track option.value + '_' + $index) {
        <mat-option [value]="option.value" [disabled]="option.disabled">
          @if (option.icon) {
            <mat-icon class="option-icon">{{ option.icon }}</mat-icon>
          }
          {{ option.label }}
        </mat-option>
      }

      @if (!loading && filteredOptions.length === 0) {
        <div class="no-results">
          No results found
        </div>
      }

      @if (enablePagination && !loading) {
        <div class="load-more-container">
          @if (hasNextPage) {
            <button mat-button class="load-more-button" (click)="loadMore(); $event.stopPropagation()">
              <span>Load More</span>
              @if (loading) {
                <mat-spinner diameter="16"></mat-spinner>
              }
            </button>
          }
        </div>
      }
    </mat-select>

    @if (hasError()) {
      <mat-hint class="error-hint">{{ customErrorMessages ? customErrorMessages : getErrorMessage() }}</mat-hint>
    } @else if (hint) {
      <mat-hint>{{ hint }}</mat-hint>
    }
  </mat-form-field>
</div>
